// URX Embeded Form
// https://github.ibm.com/dgc-web-platform/widget-form

// Must be the div id where you want the form to be loaded
export const INSTANCE_ID = 'urx-form';

// The required urx form-id to be embedded
export const CONTACT_SALES_ID = 'MAIL-dataaiwatsonxorch';
export const DIGITAL_LABOR_IDC = 'urx-53244';
export const TRIAL_WX_ORCHESTRATE = 'urx-52753';

// The required locale must be in the following format country code-language code
export const LOCALE = 'us-en';
